<template>
  <el-dialog
    :title="$t('app.adjustment')"
    :visible.sync="dialogVisible"
    width="800px"
  >
    <color-list :color-list="colorListSecond"></color-list>
    <el-row class="info">
      <el-col :span="24" style="margin-bottom: 15px"
        >{{ $t("app.adjustment") + ":" }}
        <el-cascader
          size="small"
          :show-all-levels="false"
          :clearable="true"
          v-model="selectOpt"
          :placeholder="$t('app.validation.select')"
          :props="props"
          @change="adjustInfo"
          @expand-change="getParent"
          @visible-change="closeSelect"
        >
          <template slot-scope="{ node, data }">
            <span
              v-if="node.isLeaf"
              style="
                display: inline-block;
                width: 10px;
                height: 10px;
                border-radius: 3px;
                transform: scale(1.5);
                margin-right: 10px;
              "
              :style="{ backgroundColor: data.value.split('***')[1] }"
            >
            </span>
            <span>{{ data.label }}</span>
            <div
              v-if="
                node.isLeaf &&
                data.value.split('***')[2] &&
                data.value.split('***')[2] !== 'null'
              "
              style="
                display: inline-block;
                position: relative;
                margin-left: 30px;
              "
            >
              <em
                class="el-icon-s-custom"
                @mouseenter="showStu(data.value.split('***')[2])"
              ></em>
            </div>
          </template>
        </el-cascader>
        <el-button size="small" type="primary" @click="empty">空房</el-button>
      </el-col>
      <el-col :span="12" style="margin-bottom: 15px"
        >{{ $t("app.room") + ":" + room }}
      </el-col>
      <el-col :span="12" style="margin-bottom: 15px"
        >{{ $t("app.bed") + ":" + bed }}
      </el-col>
      <el-col v-if="type === 'new'" :span="12" style="margin-bottom: 15px"
        >{{ $t("app.applicationNumber") + ":" + applyCode }}
      </el-col>
      <el-col v-else :span="12" style="margin-bottom: 15px"
        >{{ $t("app.studentNumber") + ":" + studentNumber }}
      </el-col>
      <el-col :span="12" style="margin-bottom: 15px">
        {{ $t("app.gender") + ":" + gender }}
      </el-col>
      <el-col :span="12" style="margin-bottom: 15px; word-break: normal">
        {{ $t("app.nameEnglish") + ":" + nameEnglish }}
      </el-col>
      <el-col :span="12" style="margin-bottom: 15px">
        {{ $t("app.nameChina") + ":" + nameChina }}
      </el-col>
      <el-col :span="24" style="margin-bottom: 15px">{{
        $t("app.contactInformation") + ":" + contactInformation
      }}</el-col>
    </el-row>
    <el-card class="info-card" v-show="isShow">
      <div slot="header" class="clearfix">
        <span>學生信息</span>
        <el-button
          style="float: right; padding: 3px 0"
          type="text"
          icon="el-icon-close"
          @click="closeShow"
        ></el-button>
      </div>
      <div class="stu-info-content">
        <el-form label-width="200px">
          <el-form-item label="Academic Year">
            <el-input
              disabled
              v-model="stuInfo.AcademicYear"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="Programme">
            <el-input
              disabled
              v-model="stuInfo.Programme"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="Major">
            <el-input disabled v-model="stuInfo.Major" size="small"></el-input>
          </el-form-item>
          <el-form-item label="Study Year">
            <el-input
              disabled
              v-model="stuInfo.StudyYear"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="Status">
            <el-input disabled v-model="stuInfo.Status" size="small"></el-input>
          </el-form-item>
          <el-form-item label="Student Id">
            <el-input
              disabled
              v-model="stuInfo.StudentId"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="Full Name">
            <el-input
              disabled
              v-model="stuInfo.FullName"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="Surname">
            <el-input
              disabled
              v-model="stuInfo.Surname"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="Given Name">
            <el-input
              disabled
              v-model="stuInfo.GivenName"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="Chinese Name">
            <el-input
              disabled
              v-model="stuInfo.ChineseName"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="Other Name">
            <el-input
              disabled
              v-model="stuInfo.OtherName"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="Gender">
            <el-input disabled v-model="stuInfo.Gender" size="small"></el-input>
          </el-form-item>
          <el-form-item label="Nationality">
            <el-input
              disabled
              v-model="stuInfo.Nationality"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="Birth Date">
            <el-input
              disabled
              v-model="stuInfo.BirthDate"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="Id Type">
            <el-input disabled v-model="stuInfo.IdType" size="small"></el-input>
          </el-form-item>
          <el-form-item label="Id No">
            <el-input disabled v-model="stuInfo.IdNo" size="small"></el-input>
          </el-form-item>
          <el-form-item label="Id Issue Place">
            <el-input
              disabled
              v-model="stuInfo.IdIssuePlace"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="Tel Mobile">
            <el-input
              disabled
              v-model="stuInfo.TelMobile"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="Tel Home">
            <el-input
              disabled
              v-model="stuInfo.TelHome"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="Address">
            <el-input disabled v-model="stuInfo.IdType" size="small"></el-input>
          </el-form-item>
          <el-form-item label="Email">
            <el-input disabled v-model="stuInfo.IdNo" size="small"></el-input>
          </el-form-item>
          <el-form-item label="Application Id">
            <el-input
              disabled
              v-model="stuInfo.ApplicationCode"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="Guardian Name">
            <el-input
              disabled
              v-model="stuInfo.GuardianName"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="Guardian Chinese Name">
            <el-input
              disabled
              v-model="stuInfo.GuardianChineseName"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="Guardian Relationship">
            <el-input
              disabled
              v-model="stuInfo.GuardianRelationship"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="Guardian Address">
            <el-input
              disabled
              v-model="stuInfo.GuardianAddress"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="Guardian Tel Mobile">
            <el-input
              disabled
              v-model="stuInfo.GuardianTelMobile"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="Guardian Tel Home">
            <el-input
              disabled
              v-model="stuInfo.GuardianTelHome"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="Type">
            <el-input disabled v-model="stuInfo.Type" size="small"></el-input>
          </el-form-item>
          <el-form-item label="Exchange">
            <el-input
              disabled
              v-model="stuInfo.Exchange"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="Mainland Province">
            <el-input
              disabled
              v-model="stuInfo.MainlandProvince"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="Mainland City">
            <el-input
              disabled
              v-model="stuInfo.MainlandCity"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="Hostel Room">
            <el-input
              disabled
              v-model="stuInfo.HostelRoom"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="With Mental Or Health Issue">
            <el-input
              disabled
              v-model="stuInfo.WithMentalOrHealthIssue"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="Student Visa">
            <el-input
              disabled
              v-model="stuInfo.StudentVisa"
              size="small"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" type="info" @click="dialogVisible = false">{{
        $t("app.cancel")
      }}</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="loading"
        @click="handleClose"
        >{{ $t("app.confirm") }}</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
import ColorList from "@/components/tools/ColorList";
import {
  getStudentFloorList,
  getRoomSelect
} from "@/api/systemManagement/roomManagement";
import { getBedColor } from "@/api/dormitoryManagement/list";
import { adjust } from "@/api/dormitoryManagement/preAllocOldStu";
import { change } from "@/api/dormitoryManagement/preAllocNewStu";
export default {
  components: {
    ColorList
  },
  data() {
    return {
      isShow: false,
      stuInfo: {},
      selectOpt: [],
      roomList: {},
      props: {
        lazy: true,
        lazyLoad(node, resolve) {
          const { level, value } = node;
          if (level === 0) {
            getStudentFloorList().then((res) => {
              const nodes = res.data.map((item) => ({
                value: item.FloorCode,
                label: item.FloorName,
                leaf: false,
              }));
              resolve(nodes);
            });
          }
          if (level === 1) {
            this.roomList = {};
            getRoomSelect({ FloorCode: value }).then((res) => {
              const nodes = res.data.map((item) => {
                this.roomList[item.RoomIndex] = item.BedGroup.map((items) => {
                  return {
                    value:
                      items.BedCode +
                      "***" +
                      items.BedStateColor +
                      "***" +
                      JSON.stringify(items.Student),
                    label: items.BedCode,
                    leaf: true,
                  };
                });
                return {
                  value: item.RoomIndex,
                  label: item.RoomIndex,
                  leaf: false,
                };
              });
              resolve(nodes);
            });
          }
          if (level === 2) {
            setTimeout(() => {
              const nodes = this.roomList[value].map((item) => ({
                value: item.value,
                label: item.label,
                leaf: true
              }));
              resolve(nodes);
            }, 0);
          }
        }
      },
      dialogVisible: false,
      studentNumber: "",
      applyCode: "",
      room: "",
      bed: "",
      gender: "",
      nameEnglish: "",
      nameChina: "",
      contactInformation: "",
      // other: "",
      loading: false,
      colorIndex: "",
      colorListSecond: [],
      type: ""
    };
  },
  created() {
    getBedColor().then((res) => {
      this.colorListSecond = res.data.map((item) => {
        return {
          text: item.Text,
          color: item.Color,
        };
      });
    });
  },
  methods: {
    closeSelect(val) {
      if (!val) {
        this.isShow = false;
      }
    },
    showStu(obj) {
      this.isShow = true;
      this.stuInfo = JSON.parse(obj);
    },
    closeShow() {
      this.isShow = false;
    },
    edit(row, type) {
      this.type = type || "old";
      this.selectOpt = [];
      this.dialogVisible = true;
      this.applyCode = row.applicationNumber;
      this.studentNumber = row.studentNumber;
      this.room = row.room;
      this.bed = row.bed;
      this.gender = row.gender;
      this.nameEnglish = row.nameEnglish;
      this.nameChina = row.nameChina;
      this.contactInformation = row.contactInformation;
      // this.other = row.other;
    },
    handleClose() {
      this.$confirm(this.$t("app.confirmModification") + "?").then(() => {
        this.loading = true;
        if (this.type === "old") {
          adjust({
            StudentCode: this.studentNumber,
            RoomIndex: this.room,
            Bed: this.bed,
          })
            .then(() => {
              this.success();
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          change({
            ApplicationCode: this.applyCode,
            RoomIndex: this.room,
            Bed: this.bed,
          })
            .then(() => {
              this.success();
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },
    adjustInfo() {
      if (!this.selectOpt.length) {
        this.room = "";
        this.bed = "";
        return;
      }
      this.room = this.selectOpt[1];
      this.bed = this.selectOpt[2].split("***")[0];
    },
    empty() {
      this.selectOpt = [];
      this.room = "";
      this.bed = "";
    },
    getParent(val) {
      this.colorIndex = val.splice(-1)[0];
    },
    success() {
      this.$message({
        message: this.$t("app.opeSuccess"),
        type: "success"
      });
      this.$emit("adjustSuccess");
      this.dialogVisible = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.info .el-col {
  height: 30px;
  line-height: 30px;
}
.info-card {
  position: absolute;
  width: 500px;
  height: 450px;
  top: 0;
  left: 600px;
  .stu-info-content {
    height: 350px;
    overflow: auto;
  }
}
</style>
